import { IEpiProps } from '../state-helpers/epi-props';
import * as actions from '../actions/index';
import * as _ from 'lodash';

const defaultEpiPropsModel = Object.freeze({
    cancelLabel: '',
    editLabel: '',
    noResultsErrorText: '',
    noAutocompleteResultsErrorText: '',
    emptyResultsText: '',
    amountOfResultsText: '',
    zeroResultsText: '',
    loadingResultsText: '',
    pageHeader: '',
    DefaultPageSize: 10,
    connectionErrorText: '',
    relevantSortText: '',
    alphabeticalSortText: '',
    reverseAlphabeticalSortText: '',
    newestToOldestSortText: '',
    oldestToNewestSortText: '',
    autocompleteTruncateLength: 14,
    defaultContextText: '',
    policyContextText: '',
    advocacyContextText: '',
    publicationsContextText: '',
    membersContextText: '',
    patientCareContextText: '',
    grantsContextText: '',
    guidelinesContextText: '',
    educationContextText: '',
    groupsContextText: '',
    shopContextText: '',
    resourcesContextText: '',
    initiativesContextText: '',
    programsContextText: '',
    nicuContextText: '',
    healthyChildrenContextText: '',
    newsReleasesContextText: '',
	facetsHeaderText: '',
	facetsResetLinkText: '',
	facetsLanguageTitle: '',
    facetsPriceTitle: '',
    facetsPolicyTypeTitle: '',
    facetsPolicyCategoryTitle: '',
    facetsTimeTitle: '',
    facetOrder: [],
    noFacetsText: '',
    defaultPlaceholderText: '',
    policyPlaceholderText: '',
    advocacyPlaceholderText: '',
    publicationsPlaceholderText: '',
    membersPlaceholderText: '',
    patientCarePlaceholderText: '',
    guidelinesPlaceholderText: '',
    educationPlaceholderText: '',
    groupsPlaceholderText: '',
    shopPlaceholderText: '',
    initativesPlaceholderText: '',
    programsPlaceholderText: '',
    nicuPlaceholderText: '',
    healthyChildrenPlaceholderText: '',
    grantsPlaceholderText: '',
    resourcePlaceholderText: '',
    newsReleasesPlaceholderText: '',
    suggestionText: '',
    narrowYourSeachText: '',
    generalErrorText: '',
    timeoutErrorText: '',
    redBookOnlineContextText: '',
    redBookOnlinePlaceholderText: '',
    filterWarningText: '',
    advancedMenuANDText: '',
    advancedMenuORText: '',
    advancedMenuNOTText: '',
    advancedMenuQuotesText: '',
    advancedMenuTitleText: '',
    advancedMenuPromptQueryBuilderText: '',
    advancedMenuPromptText: '',
    advancedMenuLinkText: '',
    advancedMenuLinkUrl: '',
    requiredLabelText: '',
    saveLabel: '',
    removeLabel: '',
    selectLabel: '',
    pinnedCountryNames: [],
    faapText: '',
    requiredText: '',
    optionalText: '',
    pinnedSubspecialties: [],
    personalInformationPage: '',
    professionalInformationPage: '',
    emailEditPage: '',
    phoneNumberEditPage: '',
    addressEditPage: '',
    memberDirectoryDisclaimer: '',
    searchDefaultSort: '',
    searchMembershipSort: '',
    searchPolicySort: '',
    searchPublicationsSort: '',
    searchPointofCareSort: '',
    searchShopSort: '',
    searchHealthyChildrenSort: '',
    searchNewsSort: '',
    searchRedBookSort: ''
});

export function epiPropsModel(state: IEpiProps, action: actions.IEpiPropsLoadedAction) {
    if (typeof state === 'undefined') {
        state = defaultEpiPropsModel
    }

    switch (action.type) {
        case actions.ActionType.EPI_PROPS_LOADED:
            return _.assign({}, state, action.results);
        default:
            return state;
    }
}